import { WalletTransaction } from '@/src/types/wallet'

/**
 * Maps raw API transaction to internal transaction structure
 * Shared between server-side and client-side (RTK Query) to ensure consistency
 */
export const mapRawTransaction = (raw: any): WalletTransaction => {
    let normalizedStatus: 'active' | 'inactive' | undefined
    if (raw.status) {
        const statusLower = raw.status.toLowerCase().trim()
        if (statusLower === 'active') {
            normalizedStatus = 'active'
        } else if (statusLower === 'in active' || statusLower === 'inactive') {
            normalizedStatus = 'inactive'
        }
    }

    return {
        transactionId: raw.txnId || '',
        sourceType: raw.sourceType || '',
        referenceNumber: raw.refernceNumber || raw.referenceNumber,
        txnWalletAmt: raw.txnWalletAmt || 0,
        currency: raw.currency || '',
        txnExpireDate: raw.txnExpireDate,
        status: normalizedStatus,
        createdAt: raw.txnDate || raw.createdAt
    }
}

